<template>
    <div class="page">
        <div class="logo">
            <img src="../assets/images/logo/logo1.png" alt="" />
        </div>
        <!-- <div class="theme-logo"></div> -->
        <div class="sub-logo"></div>
        <div class="info">
            <img src="../assets/images/service/bg2.jpg" alt="" />
            <!-- 白色边框 -->
            <div class="success-container" v-if="success">
                <div class="success-title">预约成功</div>
                <div>尊敬的 <span class="highlight">{{ name }}</span> 您已成功预约</div>
                <div class="pending-min-btn">请于7月23日按时与会！</div>
                <div class="success-content">
                    <div class="seat-number">
                        <div>您的座位号是：</div>
                        <div class="seat-number-text">{{ seatNumber }}</div>
                    </div>
                    <!-- <div style="color: #2196F3;" v-if="restaurant">您的餐厅是：{{ restaurant }}</div> -->
                </div>
            </div>
            <!-- 输入手机号查询 -->
            <div class="success-container" v-else>
                <div class="input-container">
                    <input v-model="mobile" type="text" placeholder="请输入姓名" style="height: 40px;" />
                </div>
                <button class="pending-btn" @click="querySeat">查询</button>
            </div>
        </div>
    </div>
    <BottomNav />
</template>

<script setup>
import { showToast, showSuccessToast } from "vant";
import BottomNav from "../components/BottomNav.vue";
import { ref } from "vue";
import { getByMobile } from "../api/user";

// 是否成功
const success = ref(false);
// 手机号
const mobile = ref("");
// 姓名
const name = ref("");
// 座位号
const seatNumber = ref("");
// 餐厅
const restaurant = ref("");
const querySeat = async () => {
    const res = await getByMobile({ mobile: mobile.value });
    if (res.code === 200) {
        name.value = res.data.name;
        seatNumber.value = res.data.seatNum || "未分配";
        restaurant.value = res.data.restaurant || "未分配";
        success.value = true;
        showSuccessToast("座位查询暂未开放");
    } else {
        success.value = false;
        showToast(res.msg);
    }
};
</script>

<style scoped>
.page {
    width: 100vw;
    height: calc(100vh - 50px);
    background: url("../assets/bg/718.jpg") 100% 100% no-repeat;
    background-size: cover;
     padding-top: 24px;
    box-sizing: border-box;
}

.logo img {
    width: 40%;
    height: 80px;
    display: block;
    margin: auto;
    padding: 30px 0;
    /* margin-left: 10%; */
    /* padding-top: 10%; */
}

.sub-logo {
    width: 90%;
    height: 30px;
    background: url("../assets/images/logo/text.png") no-repeat center center;
    background-size: contain;
    margin: auto;
}

.theme-logo {
    width: 80%;
    height: 60px;
    background: url("../assets/images/logo/aiTitle.png") no-repeat center center;
    background-size: contain;
    margin: auto;
}

.info {
    width: 82%;
    margin: auto;
    border-radius: 15px;
    margin-top: 20px;
    padding: 20px 10px;
    height: 300px;
    box-sizing: border-box;
    /* background: linear-gradient(180deg, #00b4ff, rgba(0, 123, 255, 0.3)); */
}

.info img {
    width: 100%;
    height: auto;
    display: block;
    margin: auto;
    border-radius: 10px 10px 0 0;
}

.text {
    color: #ffffff;
    text-align: center;
    margin: 5px 0;
}

.success-container {
    background: white;
    border-radius: 0 0 20px 20px;
    padding: 10px 10px;
    text-align: center;
    font-weight: 200;
    /* max-width: 00px; */
    margin: 0 auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
}

.success-container .input-container {
    margin-bottom: 10px;
}

.success-title {
    font-size: 23px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 5px;
}

.success-content {
    font-size: 16px;
    line-height: 1.8;
}

.highlight {
    color: #2196F3;
    font-weight: bold;
}

.seat-number {
    align-items: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.seat-number-text {
    background: #2196F3;
    color: white;
    border: none;
    padding: 2px 20px;
    border-radius: 10px;
    font-size: 16px;
}

.pending-btn {
     width: 150px;
    height: 40px;
    background-image: url("../assets/images/apply.png");
  /* 替换为你的背景图片路径 */
    background-size: cover;
    color: #071beb;
    border: none;
    padding: 5px 20px;
    border-radius: 15px;
    font-size: 16px;
    cursor: pointer;
    ont-weight: bold;
}

.pending-min-btn {
    cursor: pointer;
    margin-bottom: 10px;
    margin-top: 10px;
}

input {
    width: 100%;
    height: 28px;
    background: #ffffff00;
    border: none;
    border: 1px solid #02aefa;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
}
</style>
